import React, { useContext } from 'react';
import { withStyles, Divider, Button } from '@material-ui/core';
import Close from '../../asset/img/btn_action_close_nor.png';
import DataContext from '../data/DataContext';
import { closeChatbot } from '../util/utilNative';
// import ClosePressed from "../../asset/img/btn_action_close_pre.png";

const styles = (theme) => ({
  mainBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100wh%',
    height: '100vh',
  },
  warnIcon: {
    width: '2.625rem',
    height: '2.625rem',
    border: 'solid 1.8px #000',
    backgroundColor: theme.color.button.background_white,
    borderRadius: '50%',
    display: 'flex',
    // alignItems: "center",
    justifyContent: 'center',
    fontSize: theme.font.size26,
    color: theme.color.button.background_red,
    fontWeight: 'bold',
    lineHeight: '1.88',
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
  },
  maintenanceText1: {
    fontSize: theme.font.size26,
    fontWeight: 'bold',
    color: theme.color.input.text,
    margin: '24px 0 0 0',
    lineHeight: '1.88',
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
  },
  maintenanceText2: {
    fontSize: theme.font.size16,
    fontWeight: 'normal',
    lineHeight: '1.88',
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    color: theme.color.text,
    margin: '4px 0',
  },
  horizontalDivider: {
    width: '14.375rem',
    height: '1px',
    backgroundColor: theme.color.list_divider,
    border: `solid 1px #ddd`,
    margin: '25px 0 10px 0',
  },
  periodTxt: {
    //backgroundColor: "#FAFAFA",
    fontSize: theme.font.size14,
    // fontWeight: "bold",
    color: theme.color.message.period,
    textAlign: 'center',
    padding: '6px',
    lineHeight: '2.14',
    letterSpacing: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
  },
  close: {
    width: '32px',
    height: '32px',
    position: 'absolute',
    right: '6px',
    top: '6px',
    // outline: "0 none",
    border: 'none',
    background: 'transparent',
    backgroundSize: '32px',
    backgroundImage: `url(${Close})`,
    // "&:active": {
    //   backgroundImage: `url(${ClosePressed})`,
    // },
  },
  exitButton: {
    width: '-webkit-fill-available',
    margin: '0.875rem 1rem 2.25rem 1rem',
    minHeight: '3.125rem',
    backgroundColor: theme.color.button.background_red,
    color: theme.color.button.text_white,
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    padding: '0.9375rem 0',
    borderRadius: '0.375rem',
    position: 'fixed',
    bottom: 0,
    '&:active': {
      backgroundColor: 'transparent',
    },
    border: 0,
  },
});
function Maintenance(props) {
  const { classes, since, until } = props;
  const periodTxt = `${since} ~ ${until}`;
  const context = useContext(DataContext);
  // const handleClick = () => {
  //   window.NativeInterface.closeView() && window.NativeInterface.closeView();
  // };
  const handleButton = () => {
    if (context.userAgent.isLGEAPP) {
      closeChatbot(context);
    } else if (context.channel === 'lg_pc') {
      console.log("[lg_pc] postMessage('ConnAppx_d')");
      window.chrome.webview.postMessage('ConnAppx_d');
    } else {
      window.close();
    }
  };
  return (
    <>
      <div className={classes.mainBox}>
        {/* <button type="button" className={classes.close} onClick={handleClick} /> */}
        <div className={classes.warnIcon}>!</div>
        <div className={classes.maintenanceText1}>서비스 점검 중입니다.</div>
        <div className={classes.maintenanceText2}>
          더욱 똑똑한 서비스로 찾아 뵙겠습니다.
        </div>
        <Divider
          orientation={'horizontal'}
          className={classes.horizontalDivider}
          component={'div'}
          disabled
        />
        <div className={classes.periodTxt}>{periodTxt}</div>
        <button type="button" className={classes.exitButton} onClick={handleButton}>
          뒤로가기
        </button>
      </div>
    </>
  );
}
export default withStyles(styles)(Maintenance);
